import { fetchPropertyAvailabilityLogic } from './fetchPropertyAvailabilityLogic';
import { updateQueryLogic } from './updateQueryLogic';

export const logic = [fetchPropertyAvailabilityLogic, updateQueryLogic];
